import { render, staticRenderFns } from "./blockchaintransactions.vue?vue&type=template&id=541efe14"
import script from "./blockchaintransactions.vue?vue&type=script&lang=js"
export * from "./blockchaintransactions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports